/**
 * Placeholders visuels du mode démo (spécifique web).
 *
 * Style avatar d'organisation B2B : monogramme blanc sur aplat sobre et
 * désaturé, choisi de façon DÉTERMINISTE par hash du seed (nom affiché du
 * zoo). SVG inline en data URI — aucun asset à charger.
 */

import { hashString } from "./engine";

// Aplats corporate désaturés — tous calibrés pour un monogramme blanc
const LOGO_COLORS = [
  "#475569", // ardoise
  "#1e3a5f", // marine
  "#33658a", // bleu acier
  "#2f6f6b", // sarcelle sombre
  "#4b5563", // graphite
  "#3f4d8c", // indigo sourd
  "#5b5a72", // gris violacé
  "#356249", // vert sapin
];

const STOP_WORDS = new Set(["de", "des", "du", "la", "le", "les", "aux", "au", "the", "of", "der", "die", "das"]);

function initialsFrom(name) {
  const words = String(name)
    .split(/[\s\-']+/)
    .filter((w) => w && !STOP_WORDS.has(w.toLowerCase()));
  if (words.length === 0) return "ZO";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/** Logo de zoo factice : monogramme blanc sur aplat déterministe. */
export function demoZooLogoPlaceholder(seed = "Zoo") {
  const color = LOGO_COLORS[hashString(seed) % LOGO_COLORS.length];
  const initials = initialsFrom(seed);
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">` +
    `<rect width="96" height="96" rx="12" fill="${color}"/>` +
    `<text x="48" y="48" dy=".36em" text-anchor="middle" ` +
    `font-family="-apple-system,'Segoe UI',Helvetica,Arial,sans-serif" ` +
    `font-size="32" font-weight="600" letter-spacing="1" fill="#ffffff">` +
    `${initials}</text>` +
    `</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
